import { createAction, handleActions } from "redux-actions";
import * as ActionTypes from "./actionType";
import { request } from "utils/apiClient/base";

const initialState = {
  data: {},
  isLoading: false
};

export default handleActions(
  {
    [`${ActionTypes.PAGE_INIT}_PENDING`]: state => ({
      ...state,
      isLoading: true
    }),
    [`${ActionTypes.PAGE_INIT}_PENDING`]: () => initialState,
    [`${ActionTypes.PAGE_INIT}_FULFILLED`]: (state, action) => ({
      ...state,
      data: action.payload,
      isLoading: false
    }),
    [`${ActionTypes.PAGE_INIT}_REJECTED`]: (state, action) => ({
      ...state,
      error: action.payload,
      isLoading: false
    }),
    [`${ActionTypes.OTHERS_GET}_PENDING`]: state => ({
      ...state,
      isLoading: true
    }),
    [`${ActionTypes.OTHERS_GET}_FULFILLED`]: (state, action) => ({
      ...state,
      data: {
        ...state.data,
        supplychain01dto: action.payload
      },
      isLoading: false
    }),
    [`${ActionTypes.OTHERS_GET}_REJECTED`]: (state, action) => ({
      ...state,
      error: action.payload,
      isLoading: false
    })
  },
  initialState
);

export const actionCreators = {
  initPage: createAction(ActionTypes.PAGE_INIT, params => request(589, params)),
  getOthers: createAction(ActionTypes.OTHERS_GET, params =>
    request(590, params)
  )
};
